import script from "./MyVacancies.vue?vue&type=script&setup=true&lang=js"
export * from "./MyVacancies.vue?vue&type=script&setup=true&lang=js"

import "./MyVacancies.vue?vue&type=style&index=0&id=82808d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82808d2a"]])

export default __exports__